module.exports = __webpack_public_path__ + "img/001.788a3bc5.jpg";